import { Controller } from '@hotwired/stimulus';

// Removes the below-the-fold content section (Google Ads landing page content,
// /lf/:slug/c/...) once the visitor starts the funnel — answering a question
// streams an update into the lead_funnel_question frame — so the remaining
// steps stay free of distractions.
export default class extends Controller {
  connect() {
    this.remove = this.remove.bind(this);
    document.addEventListener('turbo:before-stream-render', this.remove);
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.remove);
  }

  remove(event) {
    if (event.target.target !== 'lead_funnel_question') return;

    document.removeEventListener('turbo:before-stream-render', this.remove);
    this.element.remove();
  }
}
